var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.state.App.viewerMode)?_c('div',{staticClass:"status-bar"},[_c('loading-indicator'),_c('zoom-indicator'),_c('resolution-indicator'),_c('position-indicator')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }